import script from "./BtnDeleteFocusedInstitutional.vue?vue&type=script&setup=true&lang=ts"
export * from "./BtnDeleteFocusedInstitutional.vue?vue&type=script&setup=true&lang=ts"

import "./BtnDeleteFocusedInstitutional.vue?vue&type=style&index=0&id=154359a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154359a3"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
